export const auth = 'auth';
export const userPath = 'api/user';
export const space = 'api/space';
export const SPACE_ACTIVITIES = 'api/space/space-activities';
export const BOOKING = 'api/booking/';
export const SAVINGS = 'api/booking/saving';
export const NEWSLETTER =  'api/md/newsletter';
export const HOSTONBOARDING =  'api/user/host-onboard';
export const USEDPROMOCODE = 'api/booking/used-promo-code';

export const PROMOCODE = 'api/booking/promo-code';
export const OFFLINE_BOOKING = 'api/booking/';  // Use same BOOKING endpoint, filter by type